// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1D-tZ","label":"Labeled_label__2hIzh","divider":"Labeled_divider__1dsDi"};